<template>
  <scrollable full>
    <div
      v-show="neptingInfos.offline > 0"
      class="title red text-center py-2 mb-3"
    >
      {{ $t('title.offline_trx_nb', { nb: neptingInfos.offline}) }}
    </div>

    <!-- ********************************
    ********** GESTION TICKETS **********
    ********************************* -->
    <manage-tickets />

    <!-- ******************************
    ********** LOGIN/ LOGOUT **********
    ******************************* -->
    <v-card class="pa-3 mt-2">
      <h3>
        {{ $t('title.connection') }}
      </h3>
      <v-text-field
        ref="merchantCode"
        v-model="merchantCode"
        :label="$t('field.pax.merchant_code')"
        prepend-inner-icon="person"
        name="merchantCode"
        class="needsclick"
        type="number"
        inputmode="decimal"
      />
      <v-text-field
        ref="serverNumber"
        v-model="serverNumber"
        :label="$t('field.pax.server')"
        prepend-inner-icon="mdi-format-list-bulleted"
        name="serverNumber"
        class="needsclick"
        type="number"
        inputmode="decimal"
      />
      <v-btn
        class="bloc ma-0"
        color="success"
        :disabled="loginDisabled"
        @click="login"
      >
        {{ $t('button.dw_connection') }}
      </v-btn>
      <v-btn
        class="bloc ma-0 mt-3"
        color="error"
        :disabled="!hasToken"
        @click="logout"
      >
        {{ $t('button.dw_disconnection') }}
      </v-btn>
    </v-card>

    <!-- ********************************
    ********** SIMPLE REQUESTS **********
    ********************************* -->
    <v-card class="mt-2 pa-3">
      <h3>
        {{ $t('title.requests') }}
      </h3>
      <v-btn
        v-for="(button, i) in PaxRequestEnum"
        :key="'request_' + i"
        :disabled="!hasToken"
        class="bloc ma-0 mt-3"
        @click="request(button.type)"
      >
        {{ $t(button.title) }}
      </v-btn>
    </v-card>

    <!-- ************************
    ********** REPORTS **********
    ************************* -->
    <v-card class="mt-2 pa-3">
      <h3>
        {{ $t('title.reports') }}
      </h3>
      <v-btn
        v-for="(button, i) in PaxReportsEnum"
        :key="'report_' + i"
        :disabled="!hasToken"
        class="bloc ma-0 mt-3"
        @click="report(button.type)"
      >
        {{ $t(button.title) }}
      </v-btn>
    </v-card>

    <!-- ************************
    ********** REPORTS **********
    ************************* -->
    <ticket-dialog
      :show="currentTickets !== null"
      :tickets="currentTickets"
      @close="currentTickets = null"
    />
  </scrollable>
</template>

<script>
import { PaxRequestEnum, PaxReportsEnum } from '@/modules/Enums'
import ManageTickets from '@/components/settings/banking/ManageTickets'
import TicketDialog from '../../modal/TicketDialog'
import { neptingLogin, neptingLogout, neptingReport, neptingRequest } from '@/modules/Banking'

export default {
  name: 'Nepting',

  components: {
    ManageTickets,
    TicketDialog
  },

  data () {
    return {
      PaxRequestEnum,
      PaxReportsEnum,
      //
      merchantCode: '',
      serverNumber: '',
      currentTickets: null
    }
  },

  computed: {
    neptingInfos () { return this.$store.state.neptingInfos },
    hasToken () { return this.neptingInfos.token !== null },
    loginDisabled () { return this.merchantCode.length < 5 || this.serverNumber.length < 1 }
  },

  mounted () {
    this.merchantCode = this.neptingInfos.merchantId
    this.serverNumber = this.neptingInfos.server
  },

  methods: {
    login () {
      neptingLogin(this.merchantCode, this.serverNumber)
    },
    logout () {
      neptingLogout()
    },
    request (type) {
      neptingRequest(type)
        .then((tickets) => {
          this.currentTickets = tickets
        })
    },
    report (type) {
      neptingReport(type)
        .then((tickets) => {
          this.currentTickets = tickets
        })
    }
  }
}
</script>
